import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_CANDIDATE_PAGINATION } from "../Schema/Candidate";

export const useGetCandidatePagination = ({ isActive, partyId }) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [paginationData, setPaginationData] = useState();

  const { refetch } = useQuery(GET_CANDIDATE_PAGINATION, {
    variables: {
      page: page,
      limit: limit,
      keyword: keyword,
      pagination: true,
      partyId: partyId,
      isActive: isActive,
    },
    onCompleted: ({ getCandidatePagination }) => {
      
      setTableData(getCandidatePagination?.data);
      setPaginationData(getCandidatePagination?.paginator);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  const handleSearch = (e) => {
    setPage(1);
    setKeyword(e.target.value);
  };

  useEffect(() => {
    refetch();
  }, [page, limit, keyword, partyId, isActive]);

  const handleLimit = (e) => {
    setLimit(e.target.value);
    setPage(1);
  };

  return {
    page,
    limit,
    setPage,
    refetch,
    loading,
    tableData,
    setLoading,
    handleLimit,
    handleSearch,
    paginationData,
  };
};
